export const text = {
  en: {
    title: "Shift Control",
    subtitle: "Define shifts (hours + check-in location) and assign each employee a shift or rest day per day.",
    loading: "Loading…",
    unauthorized: "You don't have permission to use Shift Control.",
    error: "Error",
    success: "Success",

    tabSchedule: "Schedule",
    tabShifts: "Shifts",

    // shifts tab
    newShift: "New Shift",
    editShift: "Edit Shift",
    noShifts: "No shifts yet. Create your first shift to start building the schedule.",
    name: "Name",
    company: "Working Company",
    allCompanies: "All companies",
    hours: "Hours",
    location: "Check-in location",
    status: "Status",
    usage: "Used",
    days: "days",
    active: "Active",
    inactive: "Inactive",
    showInactive: "Show inactive",
    overnight: "Overnight",
    nextDay: "(+1)",
    hoursShort: "h",
    radius: "Radius (m)",
    color: "Color",
    startTime: "Start time",
    endTime: "End time",
    locationName: "Location name",
    pickSaved: "Pick a saved company location",
    noSaved: "No saved locations for this company",
    mapUrl: "Google Maps link",
    mapUrlHint: "Paste a Google Maps link, or enter the coordinates below.",
    latitude: "Latitude",
    longitude: "Longitude",
    openMap: "Open map",
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    activate: "Activate",
    deactivate: "Deactivate",
    delete: "Delete",
    confirmDeleteTitle: "Delete shift",
    confirmDelete: "Delete this shift? This can't be undone.",
    confirmDeactivateTitle: "Deactivate shift",
    confirmDeactivate: "Deactivated shifts stay on past schedule days but can't be assigned any more.",
    shiftCreated: "Shift created",
    shiftUpdated: "Shift updated",
    shiftDeleted: "Shift deleted",
    overnightHint: "Ends the next day — punches after midnight count for the day the shift starts.",
    required: "Please fill name, company, times and location.",

    // schedule tab
    week: "Week",
    month: "Month",
    today: "Today",
    prev: "Previous",
    next: "Next",
    department: "Department",
    allDepartments: "All departments",
    search: "Search name or code…",
    employee: "Employee",
    noEmployees: "No employees match these filters.",
    rest: "Rest day",
    restShort: "Rest",
    weekend: "Weekend",
    clear: "— none —",
    unsaved: "unsaved change(s)",
    saveChanges: "Save changes",
    discard: "Discard",
    saved: "Schedule saved",
    recalcNote: "Past days are being recalculated in the background.",
    discardConfirm: "You have unsaved changes. Discard them?",
    discardTitle: "Unsaved changes",
    legendMore: "+{n} more",
    legendLess: "Show less",
    selected: "selected",
    selectAll: "Select all on this page",
    bulkApply: "Apply to selected",
    bulkValue: "Assign",
    from: "From",
    to: "To",
    skipWeekends: "Skip weekend days",
    apply: "Apply",
    copyPrevWeek: "Copy last week",
    copyConfirmTitle: "Copy last week",
    copyConfirm: "Replace this week's schedule with last week's for {n} employee(s)?",
    copied: "Last week copied",
    selectFirst: "Select employees first (checkbox on each row).",
    page: "Page",
    of: "of",
    legend: "Shifts",
    pastNote: "Editing past days recalculates their attendance (manual edits are kept).",
    noShiftForCompany: "No active shift for this company",
    otherCompanyShift: "Shift belongs to another company",
  },
  ar: {
    title: "إدارة الورديات",
    subtitle: "عرّف الورديات (المواعيد + موقع تسجيل الحضور) وحدد لكل موظف وردية أو يوم راحة لكل يوم.",
    loading: "جارٍ التحميل…",
    unauthorized: "ليست لديك صلاحية استخدام إدارة الورديات.",
    error: "خطأ",
    success: "تم بنجاح",

    tabSchedule: "الجدول",
    tabShifts: "الورديات",

    newShift: "وردية جديدة",
    editShift: "تعديل الوردية",
    noShifts: "لا توجد ورديات بعد. أنشئ أول وردية لبدء إعداد الجدول.",
    name: "الاسم",
    company: "الشركة",
    allCompanies: "كل الشركات",
    hours: "المواعيد",
    location: "موقع تسجيل الحضور",
    status: "الحالة",
    usage: "مستخدمة",
    days: "يوم",
    active: "نشطة",
    inactive: "غير نشطة",
    showInactive: "عرض غير النشطة",
    overnight: "ليلية",
    nextDay: "(+1)",
    hoursShort: "س",
    radius: "النطاق (م)",
    color: "اللون",
    startTime: "وقت البداية",
    endTime: "وقت النهاية",
    locationName: "اسم الموقع",
    pickSaved: "اختر موقعًا محفوظًا للشركة",
    noSaved: "لا توجد مواقع محفوظة لهذه الشركة",
    mapUrl: "رابط خرائط جوجل",
    mapUrlHint: "الصق رابط خرائط جوجل أو أدخل الإحداثيات بالأسفل.",
    latitude: "خط العرض",
    longitude: "خط الطول",
    openMap: "فتح الخريطة",
    save: "حفظ",
    cancel: "إلغاء",
    edit: "تعديل",
    activate: "تفعيل",
    deactivate: "إيقاف",
    delete: "حذف",
    confirmDeleteTitle: "حذف الوردية",
    confirmDelete: "هل تريد حذف هذه الوردية؟ لا يمكن التراجع.",
    confirmDeactivateTitle: "إيقاف الوردية",
    confirmDeactivate: "تبقى الوردية الموقوفة على الأيام السابقة لكن لا يمكن تعيينها بعد الآن.",
    shiftCreated: "تم إنشاء الوردية",
    shiftUpdated: "تم تحديث الوردية",
    shiftDeleted: "تم حذف الوردية",
    overnightHint: "تنتهي في اليوم التالي — البصمات بعد منتصف الليل تُحسب ليوم بداية الوردية.",
    required: "من فضلك أدخل الاسم والشركة والمواعيد والموقع.",

    week: "أسبوع",
    month: "شهر",
    today: "اليوم",
    prev: "السابق",
    next: "التالي",
    department: "القسم",
    allDepartments: "كل الأقسام",
    search: "ابحث بالاسم أو الكود…",
    employee: "الموظف",
    noEmployees: "لا يوجد موظفون مطابقون.",
    rest: "يوم راحة",
    restShort: "راحة",
    weekend: "عطلة",
    clear: "— بدون —",
    unsaved: "تغيير غير محفوظ",
    saveChanges: "حفظ التغييرات",
    discard: "تجاهل",
    saved: "تم حفظ الجدول",
    recalcNote: "يتم إعادة احتساب الأيام السابقة في الخلفية.",
    discardConfirm: "لديك تغييرات غير محفوظة. هل تريد تجاهلها؟",
    discardTitle: "تغييرات غير محفوظة",
    legendMore: "+{n} أخرى",
    legendLess: "عرض أقل",
    selected: "محدد",
    selectAll: "تحديد الكل في هذه الصفحة",
    bulkApply: "تطبيق على المحددين",
    bulkValue: "تعيين",
    from: "من",
    to: "إلى",
    skipWeekends: "تخطي أيام العطلة",
    apply: "تطبيق",
    copyPrevWeek: "نسخ الأسبوع الماضي",
    copyConfirmTitle: "نسخ الأسبوع الماضي",
    copyConfirm: "استبدال جدول هذا الأسبوع بجدول الأسبوع الماضي لعدد {n} موظف؟",
    copied: "تم نسخ الأسبوع الماضي",
    selectFirst: "حدد الموظفين أولًا (خانة الاختيار في كل صف).",
    page: "صفحة",
    of: "من",
    legend: "الورديات",
    pastNote: "تعديل الأيام السابقة يعيد احتساب حضورها (التعديلات اليدوية لا تتغير).",
    noShiftForCompany: "لا توجد وردية نشطة لهذه الشركة",
    otherCompanyShift: "الوردية تابعة لشركة أخرى",
  },
};

export const WEEKDAY_SHORT = {
  en: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  ar: ["أحد", "إثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
};

export const SHIFT_COLORS = [
  "#3B82F6", "#8B5CF6", "#0EA5E9", "#10B981", "#F59E0B", "#EF4444", "#EC4899", "#64748B",
];
